import styled from "styled-components";

export const Container = styled.div`
  padding: 4.8rem 2.4rem;

  ${({ theme }) => theme.media.sm`
    padding: 2.4rem;
  `}
`;
